import React, { FC } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Button } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { CHAT_BOOKING } from "../../Routes";

const ViewBookingDetailButton: FC<CustomCellRendererProps> = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => {
        navigate(`${CHAT_BOOKING}/${data.id}`);
      }}
      variant="text"
      startIcon={<RemoveRedEyeIcon />}
    >
      View more...
    </Button>
  );
};

export default ViewBookingDetailButton;
